import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_1cfd506a-8d58-4dee-aebc-bac5c6ae0bd8/artifacts/olw9pyi7_1630458636004.jpg";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[#1A4331] text-[#F3F2EB] mt-32 grain"
      data-testid="site-footer"
    >
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="bg-white rounded-sm p-2">
                <img
                  src={LOGO_URL}
                  alt="Elephant Equity"
                  className="h-8 w-8 object-contain"
                />
              </div>
            <span className="font-display text-2xl sm:text-3xl tracking-tight">
              Elephant <span className="text-[#E0A6A6]">Equity</span>
            </span>
            </div>
            <p className="font-display text-3xl sm:text-4xl font-light tracking-tighter mt-8 max-w-md leading-[1.1]">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.22em] uppercase text-[#E0A6A6] mb-5">
              {t.footer.links}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/philosophy" className="hover:text-white transition-colors">
                  {t.nav.philosophy}
                </Link>
              </li>
              <li>
                <Link to="/approach" className="hover:text-white transition-colors">
                  {t.nav.approach}
                </Link>
              </li>
              <li>
                <Link to="/sectors" className="hover:text-white transition-colors">
                  {t.nav.sectors}
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="hover:text-white transition-colors">
                  {t.nav.portfolio}
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs tracking-[0.22em] uppercase text-[#E0A6A6] mb-5">
              Offices
            </div>
            <ul className="space-y-5 text-sm">
              <li>
                <div className="font-display text-base text-white">Pune, India</div>
                <div className="text-[#E0A6A6]/90 text-xs mt-1.5 leading-relaxed">
                  3rd Floor, Sangriya Building,
                  <br />
                  Golden Trellis Road, Balewadi
                  <br />
                  Pune 411045
                </div>
              </li>
              <li>
                <div className="font-display text-base text-white">Dubai, UAE</div>
                <div className="text-[#E0A6A6]/90 text-xs mt-1.5 leading-relaxed">
                  IFZA Business Park,
                  <br />
                  Dubai Silicon Oasis,
                  <br />
                  Dubai, United Arab Emirates
                </div>
              </li>
              <li>
                <div className="text-xs tracking-[0.22em] uppercase text-[#E0A6A6] mb-1.5">
                  Contact
                </div>
                <a
                  href="mailto:info@elephantequity.in"
                  className="font-mono text-sm text-white hover:text-[#E0A6A6] transition-colors link-underline"
                  data-testid="footer-contact-email"
                >
                  info@elephantequity.in
                </a>
              </li>
              <li className="pt-2">
                <Link
                  to="/admin/login"
                  className="text-xs text-[#E0A6A6] hover:text-white transition-colors link-underline"
                  data-testid="footer-admin-link"
                >
                  {t.footer.admin}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-4 justify-between text-xs text-[#E0A6A6]">
          <span>{t.footer.copyright.replace("{year}", year)}</span>
          <span className="font-mono tracking-wider">
            EUROPE · UNITED STATES · ASIA · MIDDLE EAST
          </span>
        </div>
      </div>
    </footer>
  );
}
